import { render } from "./StepBody.vue?vue&type=template&id=06fba0fd&scoped=true"
import script from "./StepBody.vue?vue&type=script&lang=js"
export * from "./StepBody.vue?vue&type=script&lang=js"

import "./StepBody.vue?vue&type=style&index=0&id=06fba0fd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06fba0fd"]])

export default __exports__